/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReorderAssignmentRulesRequest
 */
export interface ReorderAssignmentRulesRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ReorderAssignmentRulesRequest
     */
    rule_ids: Array<string>;
}

/**
 * Check if a given object implements the ReorderAssignmentRulesRequest interface.
 */
export function instanceOfReorderAssignmentRulesRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "rule_ids" in value;

    return isInstance;
}

export function ReorderAssignmentRulesRequestFromJSON(json: any): ReorderAssignmentRulesRequest {
    return ReorderAssignmentRulesRequestFromJSONTyped(json, false);
}

export function ReorderAssignmentRulesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReorderAssignmentRulesRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'rule_ids': json['rule_ids'],
    };
}

export function ReorderAssignmentRulesRequestToJSON(value?: ReorderAssignmentRulesRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'rule_ids': value.rule_ids,
    };
}

